exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.main_mess ul{\n    overflow:hidden;\n    margin-bottom:20px;\n}\n.nav_cha {\n    padding-left: 10px;\n    border-left: 5px solid #1ab394;\n    height: 16px;\n    line-height: 16px;\n    margin: 12px;\n    font-weight: bold;\n    text-align: left;\n}\n.mess_li {\n    float: left;\n    width: 100%;\n    height:30px;\n    line-height:30px;\n    margin-left: 30px;\n    margin-top: 15px;\n    list-style: none;\n    text-align: left;\n}\n.filediv{\n    display:inline-block;\n}\n.fileimg{\n   display:block;\n   width:200px;\n   height:200px;\n   margin-left: 76px;\n}\n.back{\n    margin-left: 28px;\n    margin-bottom: 20px;\n}\n.main_mess{\n    border-top: 1px solid #ddd;\n    padding-top: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0812d1c0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/orgmgr/orgmgrDetail.vue
// module id = DtdA
// module chunks = 5